export default __webpack_public_path__ + "static/media/Brill_50_Racing_L.707a26a2.png";